'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.BANKOVNI_VYPIS_RADEK = exports.HLAVICKA_PLATBA = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ přehledové platby.
 */

var HLAVICKA_PLATBA = exports.HLAVICKA_PLATBA = 'HLAVICKA_PLATBA';

var BANKOVNI_VYPIS_RADEK = exports.BANKOVNI_VYPIS_RADEK = 'BANKOVNI_VYPIS_RADEK';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [HLAVICKA_PLATBA, BANKOVNI_VYPIS_RADEK];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, HLAVICKA_PLATBA, { caption: '' }), (0, _defineProperty3.default)(_params, BANKOVNI_VYPIS_RADEK, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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